import React from 'react';
import { Text, Pressable, useTheme } from 'native-base';
const PressableInput = ({
  handlePress,
  pressableRef,
  placeholder
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  return /*#__PURE__*/React.createElement(Pressable, {
    accessibilityLabel: 'Create new topic',
    onPress: handlePress,
    borderColor: colors.topic.createButton.border,
    borderWidth: 1,
    borderRadius: 10,
    ref: pressableRef
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.topic.createButton.text,
    px: '6',
    py: '2'
  }, placeholder));
};
export default PressableInput;
//# sourceMappingURL=PressableInput.js.map